export const INITIATE_TRANSFER_OFFPLAN_APPLICATION = 'INITIATE_TRANSFER_OFFPLAN_APPLICATION';
export const INITIATE_TRANSFER_OFFPLAN_APPLICATION_SUCCESS = 'INITIATE_TRANSFER_OFFPLAN_APPLICATION_SUCCESS';
export const INITIATE_TRANSFER_OFFPLAN_APPLICATION_ERROR = 'INITIATE_TRANSFER_OFFPLAN_APPLICATION_ERROR';
export const INITIATE_TRANSFER_OFFPLAN_APPLICATION_FAIL = 'INITIATE_TRANSFER_OFFPLAN_APPLICATION_FAIL';

export const CLEAR_TRANSFER_OFFPLAN_APPLICATION_ERROR = 'CLEAR_TRANSFER_OFFPLAN_APPLICATION_ERROR';

export const TRANSFER_OFFPLAN_LOADING = 'TRANSFER_OFFPLAN_LOADING';
export const FETCH_APPLICATION_TRANSFER_OFFPLAN_SUCCESS = 'FETCH_APPLICATION_TRANSFER_OFFPLAN_SUCCESS';
export const FETCH_PROPERTY_TRANSFER_OFFPLAN_SUCCESS = 'FETCH_PROPERTY_TRANSFER_OFFPLAN_SUCCESS';
export const FETCH_BANKLIST_TRANSFER_OFFPLAN_SUCCESS = 'FETCH_BANKLIST_TRANSFER_OFFPLAN_SUCCESS';
export const FETCH_DOCUMENTS_TRANSFER_OFFPLAN_SUCCESS = 'FETCH_DOCUMENTS_TRANSFER_OFFPLAN_SUCCESS';
export const TRANSFER_OFFPLAN_ERROR = 'TRANSFER_OFFPLAN_ERROR';

export const SET_CONTRACT_DETAILS_TEST = 'SET_CONTRACT_DETAILS_TEST';
export const SET_REGESTRATION_FEES_PAID_BY = 'SET_REGESTRATION_FEES_PAID_BY';

export const SAVE_APPLICATION_TRANSFER_OFFPLAN = 'SAVE_APPLICATION_TRANSFER_OFFPLAN';
export const SAVE_APPLICATION_TRANSFER_OFFPLAN_SUCCESS = 'SAVE_APPLICATION_TRANSFER_OFFPLAN_SUCCESS';
export const SAVE_APPLICATION_TRANSFER_OFFPLAN_ERROR = 'SAVE_APPLICATION_TRANSFER_OFFPLAN_ERROR';

export const CHANGE_TRANSFER_OFFPLAN_STEP = 'CHANGE_TRANSFER_OFFPLAN_STEP';
export const TRANSFER_OFFPLAN_CLEAR_DATA = 'TRANSFER_OFFPLAN_CLEAR_DATA';

export const DOWNLOAD_DOCUMENT_TRANSFER_OFFPLAN = 'DOWNLOAD_DOCUMENT_TRANSFER_OFFPLAN';
export const DOWNLOAD_DOCUMENT_TRANSFER_OFFPLAN_SUCCESS = 'DOWNLOAD_DOCUMENT_TRANSFER_OFFPLAN_SUCCESS';
export const DOWNLOAD_DOCUMENT_TRANSFER_OFFPLAN_ERROR = 'DOWNLOAD_DOCUMENT_TRANSFER_OFFPLAN_ERROR';

export const ADD_TO_ERROR = 'ADD_TO_ERROR';
export const ADD_TO_ERROR_INITITATE = 'ADD_TO_ERROR_INITITATE';

export const UPLOAD_TRANSFER_OFFPLAN_DOCUMENT = 'UPLOAD_TRANSFER_OFFPLAN_DOCUMENT';
export const UPLOAD_TRANSFER_OFFPLAN_DOCUMENT_SUCCESS = 'UPLOAD_TRANSFER_OFFPLAN_DOCUMENT_SUCCESS';
export const UPLOAD_TRANSFER_OFFPLAN_DOCUMENT_ERROR = 'UPLOAD_TRANSFER_OFFPLAN_DOCUMENT_ERROR';

export const CHECKOUT_TRANSFER_OFFPLAN_APPLICATION = 'CHECKOUT_TRANSFER_OFFPLAN_APPLICATION';
export const CHECKOUT_TRANSFER_OFFPLAN_APPLICATION_SUCCESS = 'CHECKOUT_TRANSFER_OFFPLAN_APPLICATION_SUCCESS';
export const CHECKOUT_TRANSFER_OFFPLAN_APPLICATION_ERROR = 'CHECKOUT_TRANSFER_OFFPLAN_APPLICATION_ERROR';

export const TRANSFER_OFFPLAN_CANCEL_APPLICATION = 'TRANSFER_OFFPLAN_CANCEL_APPLICATION';
export const TRANSFER_OFFPLAN_CANCEL_APPLICATION_SUCCESS = 'TRANSFER_OFFPLAN_CANCEL_APPLICATION_SUCCESS';
export const TRANSFER_OFFPLAN_CANCEL_APPLICATION_ERROR = 'TRANSFER_OFFPLAN_CANCEL_APPLICATION_ERROR';
export const ENROLL_PROPERTY_IN_TAWTHEEQ = 'ENROLL_PROPERTY_IN_TAWTHEEQ';
/** --------------- TRANSFER_OFFPLAN BANK MAKER --------------- */
export const SET_TRANSFER_OFFPLAN_BANK_MAKER_DETAILS = 'SET_TRANSFER_OFFPLAN_BANK_MAKER_DETAILS';

export const FETCH_TRANSFER_OFFPLAN_BANK_MAKER_APPLICATION = 'FETCH_TRANSFER_OFFPLAN_BANK_MAKER_APPLICATION';
// eslint-disable-next-line prettier/prettier
export const FETCH_TRANSFER_OFFPLAN_BANK_MAKER_APPLICATION_SUCCESS = 'FETCH_TRANSFER_OFFPLAN_BANK_MAKER_APPLICATION_SUCCESS';

// eslint-disable-next-line prettier/prettier
export const FETCH_TRANSFER_OFFPLAN_BANK_MAKER_APPLICATION_ERROR = 'FETCH_TRANSFER_OFFPLAN_BANK_MAKER_APPLICATION_ERROR';

export const SAVE_TRANSFER_OFFPLAN_BANK_MAKER_APPLICATION = 'SAVE_TRANSFER_OFFPLAN_BANK_MAKER_APPLICATION';
// eslint-disable-next-line prettier/prettier
export const SAVE_TRANSFER_OFFPLAN_BANK_MAKER_APPLICATION_SUCCESS = 'SAVE_TRANSFER_OFFPLAN_BANK_MAKER_APPLICATION_SUCCESS';
export const SAVE_TRANSFER_OFFPLAN_BANK_MAKER_APPLICATION_ERROR = 'SAVE_TRANSFER_OFFPLAN_BANK_MAKER_APPLICATION_ERROR';

export const FETCH_TRANSFER_OFFPLAN_VALUATORS = 'FETCH_TRANSFER_OFFPLAN_VALUATORS';
export const FETCH_TRANSFER_OFFPLAN_VALUATORS_SUCCESS = 'FETCH_TRANSFER_OFFPLAN_VALUATORS_SUCCESS';
export const FETCH_TRANSFER_OFFPLAN_VALUATORS_ERROR = 'FETCH_TRANSFER_OFFPLAN_VALUATORS_ERROR';
export const CLEAR_TRANSFER_OFFPLAN_VALUATORS = 'CLEAR_TRANSFER_OFFPLAN_VALUATORS';

// post flow
export const APPROVAL_TRANSFER_OFFPLAN = 'APPROVAL_TRANSFER_OFFPLAN';
export const APPROVAL_TRANSFER_OFFPLAN_SUCCESS = 'APPROVAL_TRANSFER_OFFPLAN_SUCCESS';
export const APPROVAL_TRANSFER_OFFPLAN_ERROR = 'APPROVAL_TRANSFER_OFFPLAN_ERROR';

export const POST_RETURN_TRANSFER_OFFPLAN = 'POST_RETURN_TRANSFER_OFFPLAN';
export const POST_RETURN_TRANSFER_OFFPLAN_SUCCESS = 'POST_RETURN_TRANSFER_OFFPLAN_SUCCESS';
export const POST_RETURN_TRANSFER_OFFPLAN_ERROR = 'POST_RETURN_TRANSFER_OFFPLAN_ERROR';

export const TRANSFER_OFFPLAN_PAYMENT_BREAKDOWN = 'TRANSFER_OFFPLAN_PAYMENT_BREAKDOWN';
export const TRANSFER_OFFPLAN_PAYMENT_BREAKDOWN_SUCCESS = 'TRANSFER_OFFPLAN_PAYMENT_BREAKDOWN_SUCCESS';
export const TRANSFER_OFFPLAN_PAYMENT_BREAKDOWN_ERROR = 'TRANSFER_OFFPLAN_PAYMENT_BREAKDOWN_ERROR';

export const DOWNLOAD_TRANSFEER_OFFPLAN_CONTRACT_DOCUMENT = 'DOWNLOAD_TRANSFEER_OFFPLAN_CONTRACT_DOCUMENT';
export const DOWNLOAD_TRANSFEER_OFFPLAN_CONTRACT_DOCUMENT_SUCCESS =
  'DOWNLOAD_TRANSFEER_OFFPLAN_CONTRACT_DOCUMENT_SUCCESS';
export const DOWNLOAD_TRANSFEER_OFFPLAN_CONTRACT_DOCUMENT_ERROR = 'DOWNLOAD_TRANSFEER_OFFPLAN_CONTRACT_DOCUMENT_ERROR';

export const FETCH_TRANSFER_OFFPLAN_PREMISE_ADDRESS_SUCCESS = 'FETCH_TRANSFER_OFFPLAN_PREMISE_ADDRESS_SUCCESS';

export const SET_TRANSFER_OFFPLAN_PREMISE_NUMBER = 'SET_TRANSFER_OFFPLAN_PREMISE_NUMBER';
